
export default {
  data() {
    return {
      multiselectDefaultLabels: {
        'select-label': 'Enter для выбора',
        'selected-label': 'Выбрано',
      },
    }
  },
}